
    import { Component, Vue, Prop } from "vue-property-decorator";

    @Component({
    })
    export default class WelcomeMsgPopup extends Vue {
        closeWelcomePopup() { this.$emit('closeWelcomePopup'); }
    }

